module.exports = __webpack_public_path__ + "static/media/nav-logo.19187ab1.svg";